'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Piece = function Piece(props) {
  var image = props.image,
      size = props.size,
      side = props.side,
      x = props.x,
      y = props.y,
      connectDragSource = props.connectDragSource,
      isOver = props.isOver;


  return connectDragSource(_react2.default.createElement('div', {
    style: {
      width: side + 'px',
      height: side + 'px',
      margin: '0 -1px -1px',
      border: '1px solid black',
      backgroundImage: 'url(' + image + ')',
      backgroundSize: size + 'px ' + size + 'px',
      backgroundPosition: '-' + x + 'px -' + y + 'px',
      opacity: '' + (isOver ? '0.2' : '1'),
      cursor: 'move'
    }
  }));
};

var pieceSource = {
  beginDrag: function beginDrag(props) {
    var position = props.position;


    return { position: position };
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource()
  };
}

exports.default = (0, _reactDnd.DragSource)('piece', pieceSource, collect)(Piece);